import { TwitterPixelTracker } from "./TwitterPixelTracker";
import { TwitterPixelTrackerMock } from "./TwitterPixelTrackerMock";
import { useMock } from "../utils/useMock";

export default (useMock() ? TwitterPixelTrackerMock : TwitterPixelTracker);